import React, { useState, useEffect } from 'react';
import { Layout, Button, ConfigProvider, theme } from 'antd';
import { MessageCircle } from 'lucide-react';
import { BrowserRouter as Router, Route, Routes, useLocation, useNavigate, useSearchParams, matchPath, Navigate, Outlet } from 'react-router-dom';
import Login from './Authentication/Login';
import ForgotPassword from './Authentication/ForgotPassword';
import AppHeader from './HomeDashboard/Header';
import AppSidebar from './HomeDashboard/Sidebar';
import DataTable from './Object/ObjectSetupView';
import ObjectSetupDetail from './Record/ObjectSetupDetail';
import ObjectFieldDetail from './Object/ObjectDetail';
import Import from './ImportExport/ImportWizard';
import ImportPage from './ImportExport/NewImport';
import UploadRecords from './ImportExport/UploadRecords';
import AppFooter from './HomeDashboard/Footer';
import Profile from './HomeDashboard/Profile';
import RecordDetail from './Record/RecordDetailPage';
import ErrorPage from './Components/Error'
import NotFoundError from './ErrorPages/Error-404'
import InternalServerError from './ErrorPages/Error-500'
import SetupPage from './SetupComponent/Setup';
import Home from './SetupComponent/Home';
import Cookies from 'js-cookie';
import SearchResults from './SetupComponent/SearchResults';
import ViewAllRecords from './SetupComponent/ViewAllRecords';
import ChatButton from './Components/ChatButton';
import Chat from './Chat/Chat';
import CreateReports from './Reports/CreateReport'
import ReportBuilder from '../src/Reports/ReportBuilder';
import DisplayField from './Record/RecordFieldDisplay';
import DisplayReport from './Reports/ReportDisplay';
import FloatingButton from './Components/FloatingButton';
import UtilityFloatingDrawer from './UtilityFloatingDrawer/UtilityFloatingDrawer';
import HomePage from '../src/HomeDashboard/HomePage';
import Dashboard from './SetupComponent/Dashboard';
import DashboardList from './SetupComponent/DashboardList';
import EnhancedCreateRecord from './Components/EnhancedCreateRecord';
import GridLayout from './Object/GridLayout';
import Logbook from './ModalComponents/LogBook';
import { BASE_URL } from '../src/Components/Constant';
import ApiService from '../src/Components/apiService';
import { useDispatch, useSelector } from "react-redux";
import { fetchData, fetchOrgData } from './Redux Components/dataSlice';
import eventBus from './Components/eventBus';
import AccessDenied from './ErrorPages/Error-403';
import SomethingWentWrong from './ErrorPages/Error-500';
import PageDoesnotExist from './ErrorPages/Error-404';
import UnprocessableEntity from './ErrorPages/Error-422';
import BadRequest400 from './ErrorPages/Error-400';
import Unauthorized401 from './ErrorPages/Error-401'
import ShowGridLayout from './GridLayout/ShowGridLayout';
import ResetPassword from './Authentication/ResetPassword';
import FaviconUpdater from './Components/FaviconUpdate';
import DynamicTitle from './Components/DynamicTitle';
import OrderScreen from './Components/OrderScreen';
import CreateOrg from './Authentication/CreateOrg';
import FlowScreen from './NewFlows/FlowScreen';
import SuperAdminDashboard from './SuperAdmin/SuperAdminDashboard';
import OrganizationDetails from './SuperAdmin/OrganisationDetails';
import ObjectsDashboard from './SuperAdmin/ObjectsDashboard';
import Agent from './UtilityFloatingDrawer/Agent';
import AdminAuthentication from './SuperAdmin/AdminAuthentication';
import AdminUserDetails from './SuperAdmin/AdminUserDetails';
import SidebarWidthContext from './Components/SidebarWidthContext';
import NotificationPage from './Notifications/NotificationPage';
import SystemConnectorDetail from './Connectors/SystemConnectorDetail';
import SystemConnectorsView from './Connectors/SystemConnectorsView';
import CustomConnectionsTable from './Connectors/CustomConnectorsTable';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import CustomConnectionsView from './Connectors/CustomConnectionsView';
import ZohoAuthenticate from './Connectors/AuthenticateRedirectURl';
import DiffCheckerHome from './Salesforce Tools/DiffChecker/DiffCheckerHome';
import DiffCheckerConnections from './Salesforce Tools/Connections/OrgConnections';
import DiffCheckerAuthenticate from './Salesforce Tools/Connections/OrgAuthenticate';
import MigrationToolSetup from './Salesforce Tools/RCAMigrationTool/MigrationToolSetup';
import SalesforceToolHome from './Salesforce Tools/SalesforceToolHome';
import SalesforceToolsDashboard from './Salesforce Tools/SalesforceToolsDashboard';
import DiffInsightLandingPage from './LandingPages/DiffInsightLandingPage';
import DiffCheckerSetup from './Salesforce Tools/DiffChecker/DiffCheckerSetup';
import DiffConnections from './Salesforce Tools/DiffChecker/DiffCheckerConnections';
import PipelineBuilder from './PipelineBuilder/PipelineBuilder';
// import RcaConnections from './Salesforce Tools/RCAMigrationTool/RcaConnections';
// import MigrationToolHome from './Salesforce Tools/RCAMigrationTool/MigrationToolHome';
import Help from './LandingPages/Help';
import Products from './LandingPages/Products';
import Timesheet from './Components/Timesheet/Timesheet';
import CustomComponentRender from './Components/CustomComponentRender';
import CaratsAndGoldLandingPage from './LandingPages/CaratsAndGoldLandingPage';
import ProfilePage from './LandingPages/ProfilePage';


const { Header, Sider, Content } = Layout;

const sidebarRoutes = [
  '/object-setup',
  '/object-setup/:id',
  '/record/:objectid/:objectName/:id',
  '/object/:id',
  '/object-profile',
];


const diffInsightAllowedRoutes = [
  '/diffinsight/home',
  '/diffinsight/connections',
  '/products/diffinsight'
];


ModuleRegistry.registerModules([AllCommunityModule]);

const App = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const authRoutes = [
    "/login",
    "/signup",
    "/forgot-password",
    "/ResetPassword/:token",
    "/Register",
    "/Admin",
    "/products/diffinsight",
    "/Admin/objects/:orgId",
    "/Admin/organization/:id",
    "/Admin/Authentication",
    "/Admin/users/:orgId",
    "/help",
    "/products",
    "/",
    "/caratsandgold",
    "/profile/:id"
  ];



  const isAuthPage = authRoutes.some((route) =>
    matchPath({ path: route, end: true }, location.pathname)
  );

  // Sidebar width state
  const [drawers, setDrawers] = useState([]);
  const [chatEnabled, setChatEnabled] = useState(false);
  const [utilityEnabled, setUtilityEnabled] = useState(false);
  const [gridViewEnabled, setGridViewEnabled] = useState(true);
  const [agentEnabled, setAgentEnabled] = useState(false);
  const token = Cookies.get('tokenRes');
  const security = useSelector((state) => state.data.items[0]);
  const [open, setOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(true);
  const [sidebarWidth, setSidebarWidth] = useState("15%"); // expanded by default


//   useEffect(() => {
//   const currentHost = window.location.host;
//   const currentPath = location.pathname;

//   if (currentHost === 'diffinsight.mind-mesh.com') {
//     const isAllowed = diffInsightAllowedRoutes.some(route =>
//       matchPath({ path: route, end: false }, currentPath)
//     );

//     if (!isAllowed) {
//       navigate('/Error/404', { replace: true });
//     }
//   }
// }, [location, navigate]);


  useEffect(() => {
    dispatch(fetchData());
    dispatch(fetchOrgData());
  }, [dispatch, token]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    const host = window.location.host;

    const token = Cookies.get('tokenRes');
    if (!token && !isAuthPage) {
      navigate('/');
    }
  }, [location, navigate, isAuthPage]);

  useEffect(() => {
    const isSidebarRoute = sidebarRoutes.some(route => location.pathname.startsWith(route));
    if (!isSidebarRoute) {
      localStorage.removeItem('selectedKey');
    }
  }, [location.pathname]);

  // Sidebar toggle handler
  const handleSidebarToggle = (width) => {
    setSidebarWidth(width);
  };

  const isChatRoute = location.pathname === '/chat';

  useEffect(() => {
    if (isChatRoute) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isChatRoute]);

  const showDrawer = () => {
    setDrawers((prevDrawers) => {
      const updatedDrawers = prevDrawers.map((drawer) => ({
        ...drawer,
        leftPosition: drawer.leftPosition - 750,
      }));

      return [
        ...updatedDrawers,
        {
          key: Date.now(),
          visible: true,
          leftPosition: window.innerWidth - 550,
        },
      ];
    });
  };

  const closeDrawer = (key) => {
    setDrawers((prevDrawers) => {
      const filteredDrawers = prevDrawers.filter((drawer) => drawer.key !== key);

      return filteredDrawers.map((drawer, index) => ({
        ...drawer,
        id: index,
        leftPosition: window.innerWidth - 550 - (filteredDrawers.length - 1 - index) * 750,
      }));
    });
  };

  const showAgentDrawer = () =>{
    navigate('/AptAI');
  }

  useEffect(() => {
    fetchOrgSetupDetails();
    eventBus.on("OrgSetupUpdate", fetchOrgSetupDetails);

    return () => {
      eventBus.off("OrgSetupUpdate", fetchOrgSetupDetails);
    };
  }, []);

  const fetchOrgSetupDetails = async () => {
    const orgId = Cookies.get('orgId');
    try {
      const apiService = new ApiService(
        `${BASE_URL}/org_infos/${orgId}`,
        { 'Content-Type': 'application/json' },
        'GET'
      );
      const response = await apiService.makeCall();
      const timezone = response?.defaultTimezone || 'UTC';
      const locale = response?.defaultLocale || 'India';
      Cookies.set('timezone', timezone, { expires: 7 });
      Cookies.set('Locale', locale, { expires: 7 });

      setChatEnabled(response?.chat);
      setUtilityEnabled(response?.utility);
      setGridViewEnabled(response?.gridView);
      setAgentEnabled(response?.agent);

    } catch (error) {
      console.error("Error fetching org details:", error);
    }
  };

  return (

    <SidebarWidthContext.Provider value={sidebarWidth}>
      <Layout>
        <Layout style={{ minHeight: '100vh', overflow: 'hidden', position: 'relative' }}>
          {!isAuthPage && (
            <AppHeader />
          )}

          {!isAuthPage &&
            !location.pathname.startsWith('/setup') &&
            !location.pathname.startsWith('/diffinsight') &&
            // !location.pathname.startsWith('/RCA') &&
            // !location.pathname.startsWith('/Connections') && 
            !matchPath({ path: "/GridLayout/:objectName" }, location.pathname) &&
            !matchPath({ path: "/setup/Dashboard/:id?" }, location.pathname) && (
              <AppSidebar
                collapsed={collapsed}
                onSidebarToggle={handleSidebarToggle}
                collapsedWidth="0px"
                expandedWidth="15%"
              />
            )}

          <Layout
            style={{
              marginLeft: (
                !isAuthPage &&
                !location.pathname.startsWith('/setup') &&
                !location.pathname.startsWith('/diffinsight') &&
                // !location.pathname.startsWith('/RCA') &&
                // !location.pathname.startsWith('/Connections') &&
                !matchPath({ path: "/GridLayout/:objectName" }, location.pathname) &&
                !matchPath({ path: "/setup/Dashboard/:id?" }, location.pathname)
              ) ? sidebarWidth : '0',
              marginTop: !isAuthPage ? '64px' : '0',
            }}
          >
            <Content
              style={{
                padding: '0',
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 0,
                height: 'auto', // 👈 natural height in setup
                overflow: 'unset',
              }}
            >
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/ResetPassword/:token" element={<ResetPassword />} />
                <Route path="/Register" element={<CreateOrg />} />
                <Route path="setup/objectManager" element={<DataTable />} />
                <Route path="/setup/object-setup/:id" element={<ObjectFieldDetail />} />
                <Route path="/record/:objectName/:id" element={<ShowGridLayout />} />
                {security?.system_settings?.import_records?.create === true && (
                  <>
                    <Route path="/setup/import" element={<Import />} />
                    <Route path="/setup/import/new-import" element={<ImportPage />} />
                    <Route path="/setup/import/new-import/standard" element={<UploadRecords />} />
                  </>
                )}
                <Route path="/object/:id" element={<ObjectSetupDetail gridViewEnabled={gridViewEnabled} />} />
                <Route path="/object-profile" element={<Profile />} />
                <Route path="/customcomponent/:component_name" element={<CustomComponentRender />} />
                <Route path="/caratsandgold" element ={<CaratsAndGoldLandingPage/>} />

                <Route path='/timesheet' element={<Timesheet />} />
                <Route path="/setup" element={<SetupPage />} />
                <Route path="/Error" element={<ErrorPage />} />
                <Route path="/Error/404" element={<NotFoundError />} />
                <Route path="/Error/500" element={<InternalServerError />} />
                <Route path="/SearchResults" element={<SearchResults />} />
                <Route path="/ViewAllRecords" element={<ViewAllRecords />} />
                <Route path="/Notifications" element={<NotificationPage />} />
                <Route path="/setup/SystemConnectors" element={<SystemConnectorsView />} />
                <Route path="/setup/PipelineBuilder" element={<PipelineBuilder />} />
                <Route path="/setup/PipelineBuilder/:id" element={<PipelineBuilder />} />
                <Route path="/setup/SystemConnectors/:id?" element={<SystemConnectorDetail />} />
                <Route path="/setup/CustomConnectors" element={<CustomConnectionsTable />} />
                <Route path="/setup/CustomConnectors/:id?" element={<CustomConnectionsView />} />
                <Route path="/authenticate" element={<ZohoAuthenticate />} />
                <Route path="/products/diffinsight" element ={<DiffInsightLandingPage />} /> 
                <Route path="/help" element={<Help />} />
                <Route path='/products' element={<Products />} />
                <Route path='/AptAI' element={<Agent />} />
                <Route path="/profile/:id" element={<ProfilePage />} />
                
                {chatEnabled ?
                  <Route path="/chat" element={<Chat isChatEnabled={chatEnabled} />} /> :
                  <Route path="/chat" element={<Unauthorized401 />} />
                }
                {security?.system_settings?.report?.view === true && (
                  <>
                    <Route path="/setup/Reports" element={<CreateReports />} />
                  </>
                )}
                {security?.system_settings?.report?.view === true && security?.system_settings?.report?.edit === true && security?.system_settings?.report?.create === true && (
                  <>
                    <Route path="/setup/ReportBuilder" element={<ReportBuilder />} />
                  </>
                )}
                <Route path="/ViewReport/:id" element={<DisplayReport />} />
                {security?.system_settings?.dashboard?.view === true && (
                  <>
                    <Route path='/setup/DashboardList' element={<DashboardList />} />
                  </>
                )}
                <Route path="/setup/Dashboard/:id?" element={<Dashboard />} />
                {(security?.system_settings?.flexi_page?.create === true && security?.system_settings?.flexi_page?.edit === true) ?
                  <Route path="/GridLayout/:objectName" element={<GridLayout />} /> :
                  <Route path="/GridLayout/:objectName" element={<Unauthorized401 />} />
                }
                <Route
                      path="/"
                      element={token ? <Navigate to="/Home" replace /> : <HomePage />}
                    />
                    <Route
                      path="/Home"
                      element={token ? <HomePage /> : <Navigate to="/" replace />}
                />                
                <Route path="/AccessDenied" element={<AccessDenied />} />
                <Route path="/SomethingWentWrong" element={<SomethingWentWrong />} />
                <Route path="/PageDoesNotExist" element={<PageDoesnotExist />} />
                <Route path="/UnprocessableEntity" element={<UnprocessableEntity />} />
                <Route path="/BadRequest" element={<BadRequest400 />} />
                <Route path="/Unauthorized" element={<Unauthorized401 />} />
                {security?.system_settings?.flow?.create === true && (
                  <>
                    <Route path="/Flows" element={<FlowScreen />} />
                  </>
                )}

                {Cookies.get("SuperAdminToken") ? (
                  <>
                    <Route path="/Admin" element={<SuperAdminDashboard />} />
                    <Route path="/Admin/organization/:id" element={<OrganizationDetails />} />
                    <Route path="/Admin/objects/:orgId" element={<ObjectsDashboard />} />
                    <Route path="/Admin/Authentication" element={<AdminAuthentication />} />
                    <Route path="/Admin/users/:orgId" element={<AdminUserDetails />} />
                  </>
                ) : (
                  <>
                    <Route path="/Admin/Authentication" element={<AdminAuthentication />} />
                    <Route path="/Admin/*" element={<Navigate to="/Admin/Authentication" replace />} />
                  </>
                )}

                <Route path="/diffinsight/*" element={<DiffCheckerSetup />}>
                  <Route path="home" element={<DiffCheckerHome />} />
                  <Route path="connections" element={<DiffConnections />} />
                </Route>

                 {/* <Route path="/rcamigration/*" element={<MigrationToolHome />}>
                  <Route path="home" element={<MigrationToolSetup />} />
                  <Route path="connections" element={<RcaConnections/>} />
                </Route> */}


                {/* <Route path="/RCA/Home" element={<DiffCheckerHome />} />
                <Route path="/RCA/Connections" element={<DiffCheckerConnections />} />
                <Route path="/RCA/AuthenticateOrg" element={<DiffCheckerAuthenticate />} />

                <Route path="/SalesforceTools" element={<SalesforceToolHome />}>
                  <Route path="Home" element={<SalesforceToolsDashboard />} />
                  <Route path="RCAMigration" element={<MigrationToolSetup />} />
                  <Route path="DiffInsight" element={<DiffCheckerHome />} />
                  <Route path="Connections" element={<DiffCheckerConnections />} />
                  <Route path="AuthenticateOrg" element={<DiffCheckerAuthenticate />} />
                </Route> */}

              </Routes>
            </Content>
            <FaviconUpdater />
            <DynamicTitle />

            {!isChatRoute && !isAuthPage && chatEnabled && <ChatButton />}
            {!isChatRoute && !isAuthPage && utilityEnabled &&
              <>
                <FloatingButton onClick={showDrawer} />
                {drawers.map((drawer, index) => (
                  <UtilityFloatingDrawer
                    key={drawer.key}
                    visible={drawer.visible}
                    onClose={() => closeDrawer(drawer.key)}
                    leftPosition={drawer.leftPosition}
                  />
                ))}
              </>
            }
            {!isChatRoute && !isAuthPage && agentEnabled &&
              <>
                <Button
                  type="primary"
                  shape="circle"
                  icon={<MessageCircle size={15} />}
                  style={{
                    position: "fixed",
                    bottom: 20,
                    right: 20,
                    width: 40,
                    height: 40,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  }}
                  onClick={showAgentDrawer}
                />
                {/* <Agent setOpen={setOpen} open={open} /> */}
              </>
            }
          </Layout>
        </Layout>
        {/* {!isAuthPage && !isChatRoute && <AppFooter />} */}
      </Layout>
    </SidebarWidthContext.Provider>

  );
};

const AppWrapper = () => (
  <Router>
    <App />
  </Router>
);

export default AppWrapper;
